import { environment as defaultEnvironment } from './environment.default';

export const environment = {
  ...defaultEnvironment,

  platform: 'softswiss',
  //see: defaultEnvironment + configService
  //most of the variables are irrelevant for this brand, since it has only landings (overwrites are just to be pretty)

  // --- Features & Flags ---
  isLandingsOnly: true,
  ctaLinks: {
    home: "https://www.slotvibe.com/?sign-up=modal", //todo refactor for redirectUser method but slotvibe.com is unavailable for now (checked 20 april 2026)
    casino: undefined,
    sport: undefined
  },

  // --- Core Identification & Branding --- ==> irrelevant
  rivalName: "slotvibe",
  prettyName: "Slotvibe",
  rivalChatGroupName: "slotvibe",

  //SEO
  GA_TRACKING: "G-WVFX65661H",
  metaDescription: "SlotVibe Casino, the best online casino to vibe with free slots. No deposit bonuses, free spins, welcome bonus and free chip slot game await at SlotVibe Casino.",
  logoName: "slotvibe-online-casino-logo.png",
  logoAltText: "SlotVibe Online Casino Logo with Day of the Dead character, golden text, poker chip, Online Slots, Free Spins, Real Money Games"

}
